import { BaseModel } from "@blue-chip/core";

export default class BidGroupSpec extends BaseModel {}
